var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-file-upload", {
        attrs: {
          fileGroup: "image-goods",
          onBeforeUpload: _vm.onBeforeUpload,
          onProgress: _vm.onProgress,
          onDone: _vm.onUploadDone,
          multipleFile: true
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "file-area clearfix" },
        _vm._l(_vm.contractFileList, function(file, index) {
          return _c("swb-file-item", {
            attrs: {
              trackKey: index,
              fileName: file.name,
              fileUuid: file.fileUuid,
              fileDownloadUrl: file.fileDownloaddUrl,
              fileMd5: file.fileMd5,
              editable: _vm.showDelete,
              deletable: _vm.showDelete,
              onDelete: _vm.deleteFile
            }
          })
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-688d7911", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d7911","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/SaveFile.vue
// module id = 2740
// module chunks = 0